import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import { IconButton } from '@mui/material';
import { FC } from 'react';
import { SlideComponentCharacterSoundModel } from '@/types/slide';

/**
 * Pronunciation component to play audio for a given phrase.
 *
 * NOTE: At this point, it is better to just use existing Text-to-Speech service to create the audio on the fly.
 *       With nowadays GenAI, it is much better to have a TTS service that can generate the audio than we cocatenate the audio files in order to form a phrase.
 */

interface PronunciationProps {
    checkLegacyLogic?: (soundLength: number, phraseLength: number) => boolean;
    phraseSound: SlideComponentCharacterSoundModel;
    phrase: string;
    groupIndex: number;
    folder: 'jyutping' | 'pinyin';
}

export const Pronunciation: FC<PronunciationProps> = ({ checkLegacyLogic, phraseSound, phrase, groupIndex, folder }) => {
    const playAudio = () => {
        const isLegacyLogic = checkLegacyLogic ? checkLegacyLogic(phraseSound[folder]?.[0]?.sound?.split(' ')?.length ?? 0, phrase.length) : false;

        let soundFileName: string[] = [];
        if (isLegacyLogic) {
            const phraseCharacterCount = phrase.replace(/[（）()]/g, '').length;
            const sounds = phraseSound[folder]?.[0]?.sound.split(' ');
            if (sounds) {
                soundFileName = sounds.slice(groupIndex * phraseCharacterCount, groupIndex * phraseCharacterCount + phraseCharacterCount);
            }
        } else {
            if (phraseSound?.[folder]?.[groupIndex]) {
                soundFileName = phraseSound[folder][groupIndex].sound.split(' ');
            }
        }

        const audio = new Audio();
        audio.src = '/asset/characters/sounds/' + folder + '/' + soundFileName?.[0] + '.mp3';
        let count = 0;
        audio.onended = function () {
            count++;
            audio.src = '/asset/characters/sounds/' + folder + '/' + soundFileName?.[count] + '.mp3';
            if (soundFileName && count > soundFileName.length - 1) {
                count = 0;
            } else {
                audio.play();
            }
        };
        audio.play();
    };

    // Render nothing, this component only plays sounds
    return (
        <IconButton
            sx={(theme) => ({
                height: 24,
                width: 24,
                backgroundColor: (theme.vars || theme).palette.grey[200],
                ...theme.applyStyles('dark', {
                    backgroundColor: (theme.vars || theme).palette.grey[700],
                }),
            })}
            onMouseDown={(e) => {
                e.stopPropagation();
            }}
            onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();

                playAudio();
            }}
        >
            <VolumeUpIcon fontSize='small' />
        </IconButton>
    );
};
